export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Загальна сума до списання"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Комісія"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Інфо"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["До зарахування"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Неможливо розрахувати суму"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Недостатньо коштів для проведення платежу"])}
}